import React from "react";
import nutritionImage from "../assets/images/marea-wellness-YEjwA2TofhQ-unsplash.jpg";
import ContactUs from "./organisms/ContactUs";
import HeadingText from "./atoms/HeadingText";
import ContentText from "./atoms/ContentText";
import useTranslate from "../hooks/useTranslate";

function SportsNutrition() {
  const heading = useTranslate(
    "workwithMnPage.sportsNutrition.section.heading"
  );
  const subheading = useTranslate(
    "workwithMnPage.sportsNutrition.section.subheading"
  );
  const contentText = useTranslate(
    "workwithMnPage.sportsNutrition.section.contentText"
  );

  return (
    <>
      <section className="bg-white py-12">
        <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row">
          <div className="basis-1/2 mb-4">
            <img
              src={nutritionImage}
              alt="Nutrition"
              className="md:max-w-[90%] max-w-[100%]"
            />
          </div>
          <div className="basis-1/2">
            <HeadingText variant="h2">{heading}</HeadingText>
            <HeadingText variant="h3">{subheading}</HeadingText>
            <ContentText>{contentText}</ContentText>
          </div>
        </div>
      </section>
      <ContactUs />
    </>
  );
}

export default SportsNutrition;
